import Button from 'components/common/Button';
import { useRetryAppointmentSyncToBookingkitMutation } from 'graphql/mutations/appointment/generated/RetryAppointmentSyncToBookingkit';
import React from 'react';
import { ArrowRepeat } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { formatGraphqlErrors } from 'utils/helpers';

const RetryBookingkitSyncButton: FC<{ appointmentId: string }> = ({ appointmentId }) => {
  const { t } = useTranslation();

  const [retryAppointmentSyncToBookingkitMutation, { loading }] = useRetryAppointmentSyncToBookingkitMutation({
    variables: { appointmentId },
    onCompleted: () => {
      toast.success(t('appointments.bookingkitCell.syncScheduled'));
    },
    onError: (error) => {
      toast.error(formatGraphqlErrors(error).message);
    },
  });

  return (
    <Button
      size="sm"
      variant="link"
      loading={loading}
      disabled={loading}
      onClick={() => retryAppointmentSyncToBookingkitMutation()}
    >
      <small>
        {t('appointments.bookingkitCell.retrySyncButton')} <ArrowRepeat />
      </small>
    </Button>
  );
};

export default RetryBookingkitSyncButton;
